<template>
  <transition name="mei-toast-fade">
    <div v-if="show" class="toast-container">
      <div v-if="type!=='none'" class="toast-icon">
        <i :class="['iconfont',iconClass]"></i>
      </div>
      <div class="toast-text">{{text?text:'系统异常，请稍后重试'}}</div>
    </div>
  </transition>
</template>

<script type="text/babel">
const typeMap = {
  success: 'icon-success',
  info: 'icon-prompt',
  warning: 'icon-prompt',
  error: 'icon-error',
  none: ''
};
export default {
  data() {
    return {
      show: false,
      text: '',
      type: ''
    };
  },
  computed: {
    iconClass() {
      return typeMap[this.type];
    }
  },
};
</script>
<style lang="less" >
.toast-container {
  max-width: 60%;
  min-width: 120px;
  padding: 14px 14px;
  color: rgb(255, 255, 255);
  text-align: center;
  border-radius: 4px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  z-index: var(--toast-index);
  background: rgba(0, 0, 0, .7);
  display: flex;
  flex-direction: column;
  align-items: center;

  .toast-icon {
    width: 80px;
    height: 80px;
    text-align: center;
    line-height: 80px;
    font-size: 60px;
  }

  .toast-text {
    color: #ffffff;
    font-size: 16px;
  }
}

.mei-toast-fade-enter-active {
  transition: all 0.3s linear;
}

.mei-toast-fade-leave-active {
  transition: all 0.3s linear;
}

.mei-toast-fade-enter,
.mei-toast-fade-leave-to {
  opacity: 0;
}
</style>